// Testimonial "See original / See translation" toggle.
// Each translated quote renders a button; clicking swaps the quote text
// in place and flips the label. Re-initialized on page:load (router swaps <main>).
(function () {
  function init() {
    document.querySelectorAll('.testimonial__toggle').forEach((btn) => {
      if (btn._bound) return;
      btn._bound = true;

      const quote =
        btn.closest('.testimonial-quote')?.querySelector('.testimonial-quote__text') ||
        btn.closest('.testimonial-slide')?.querySelector('.testimonial-slide__quote');
      if (!quote) return;

      const translation = quote.textContent.trim();
      const original = btn.getAttribute('data-original');
      const originalLabel = btn.getAttribute('data-original-label');
      const translationLabel = btn.getAttribute('data-translation-label');

      btn.addEventListener('click', () => {
        const showingOriginal = btn.getAttribute('aria-expanded') === 'true';
        if (showingOriginal) {
          quote.textContent = translation;
          btn.textContent = originalLabel;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          quote.textContent = original;
          btn.textContent = translationLabel;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('page:load', init);
  document.addEventListener('DOMContentLoaded', init);
})();
